// extracted by mini-css-extract-plugin
export default {"toolbar":"NotesToolbar_toolbar__zvhmt","ctaSection":"NotesToolbar_ctaSection__LbC10","ctaText":"NotesToolbar_ctaText__aXZs-"};